var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRankingListFill2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2638_3874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5.75H12.7501C12.9048 5.75 13.0532 5.81146 13.1626 5.92085C13.272 6.03025 13.3334 6.17862 13.3334 6.33333V12.1667C13.3334 12.3214 13.272 12.4697 13.1626 12.5791C13.0532 12.6885 12.9048 12.75 12.7501 12.75H2.25008C2.09537 12.75 1.947 12.6885 1.8376 12.5791C1.72821 12.4697 1.66675 12.3214 1.66675 12.1667V5.75ZM2.25008 2.25H11.0001V4.58333H1.66675V2.83333C1.66675 2.67862 1.72821 2.53025 1.8376 2.42085C1.947 2.31146 2.09537 2.25 2.25008 2.25ZM9.25008 8.66667V9.83333H11.0001V8.66667H9.25008Z",
    fill: "url(#paint0_linear_2638_3874)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2638_3874",
    x1: 2.323,
    y1: 2.25,
    x2: 15.0737,
    y2: 6.52203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DFFA6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2638_3874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingListFill2);
export default __webpack_public_path__ + "static/media/RankingList-fill2.f8b10e3898736c052e365b5ac0899db2.svg";
export { ForwardRef as ReactComponent };